




































import { Component, Vue } from 'vue-property-decorator'
import firebase from 'firebase/app'
import db from '@/firebase/firebaseConfig'
@Component({
  name: 'AllIdea'
})
export default class AllIdea extends Vue {

  ideas: any[] = []
  isLoading: boolean = false

  mounted() {
    this.getItems()
  }

  async getItems() {
    console.log('getItems')
    this.isLoading = true
    await this.readFirestore()
    this.isLoading = false
  }

  async readFirestore() {
    try {
      this.ideas = []
      const items: firebase.firestore.QuerySnapshot = await db.collection('ideas').get()
      items.docs.forEach((item: firebase.firestore.QueryDocumentSnapshot) => {
        let idea = item.data()
        idea.id = item.id
        idea.title = idea.title.replace(/\n/g, '<br>')
        this.ideas.push(idea)
      })
      console.log(this.ideas)
    } catch (error) {
      console.error('firebase error', error)
    }
  }

  openIdea(idea: any) {
    this.$router.push({ name: 'ViewIdea', params: { id : idea.id } })
  }

}
